export const WIDGET_TTS_SAMPLE_PHRASE = 'Olá! Esta é a voz que o widget vai usar neste computador.';

export const WIDGET_TTS_HELP_TEXT = 'A lista mostra as vozes instaladas neste navegador. O visitante pode não ter a mesma voz. Nesse caso o widget usa outra voz pt-BR do dispositivo dele, se houver.';

export const WIDGET_TTS_SAVED_OPTION = '__saved__';

export function normTts(value: string | null | undefined): string
{
  return String(value || '').trim();
}

export function normalizeVoiceLang(lang: string | null | undefined): string
{
  return String(lang || '').trim().replace(/_/g, '-').toLowerCase();
}

export function isPtBrVoiceLang(lang: string | null | undefined): boolean
{
  const normalized = normalizeVoiceLang(lang);
  return normalized === 'pt-br' || normalized.startsWith('pt-br-');
}

export function isPortugueseVoiceLang(lang: string | null | undefined): boolean
{
  const normalized = normalizeVoiceLang(lang);
  return normalized === 'pt' || normalized.startsWith('pt-');
}

export function ttsOptionValue(voice: SpeechSynthesisVoice): string
{
  const uri = normTts(voice.voiceURI);
  if (uri)
  {
    return uri;
  }

  return `name:${normTts(voice.name)}`;
}

export function savedTtsOptionValue(
  uri: string | null | undefined,
  name: string | null | undefined
): string
{
  const trimmedUri = normTts(uri);
  if (trimmedUri)
  {
    return trimmedUri;
  }

  const trimmedName = normTts(name);
  if (trimmedName)
  {
    return `name:${trimmedName}`;
  }

  return '';
}

export function resolveWidgetTtsVoice(
  uri: string | null | undefined,
  name: string | null | undefined,
  voices: SpeechSynthesisVoice[]
): SpeechSynthesisVoice | null
{
  const wantedUri = normTts(uri);
  const wantedName = normTts(name);
  if (!wantedUri && !wantedName)
  {
    return null;
  }

  const list = voices || [];
  if (wantedUri)
  {
    const byUri = list.find((voice) => normTts(voice.voiceURI) === wantedUri);
    if (byUri)
    {
      return byUri;
    }
  }

  if (wantedName)
  {
    const byName = list.find((voice) => normTts(voice.name) === wantedName);
    if (byName)
    {
      return byName;
    }

    const wantedLower = wantedName.toLowerCase();
    const byNameIgnoreCase = list.find((voice) => normTts(voice.name).toLowerCase() === wantedLower);
    if (byNameIgnoreCase)
    {
      return byNameIgnoreCase;
    }
  }

  const ptBr = list.find((voice) => isPtBrVoiceLang(voice.lang));
  if (ptBr)
  {
    return ptBr;
  }

  const portuguese = list.find((voice) => isPortugueseVoiceLang(voice.lang));
  if (portuguese)
  {
    return portuguese;
  }

  return null;
}

export function buildTtsVoiceLabel(voice: SpeechSynthesisVoice, peers: SpeechSynthesisVoice[]): string
{
  const name = voice.name || '';
  const sameName = peers.filter((item) => (item.name || '') === name);
  if (sameName.length < 2)
  {
    return name;
  }

  const serviceSuffix = voice.localService ? ' (neste dispositivo)' : ' (online)';
  const withService = `${name}${serviceSuffix}`;
  const stillSame = sameName.filter((item) => {
    const itemSuffix = item.localService ? ' (neste dispositivo)' : ' (online)';
    return `${item.name || ''}${itemSuffix}` === withService;
  });
  if (stillSame.length < 2)
  {
    return withService;
  }

  const tail = normTts(voice.voiceURI).slice(-8);
  return `${withService} — ${tail}`;
}

export function readSpeechError(event: { error?: string } | null | undefined): string
{
  try
  {
    if (event && event.error)
    {
      return String(event.error);
    }
  }
  catch
  {
    return '';
  }

  return '';
}
